import { SetStateAction, Dispatch } from 'react'
import { ToggleButton, ToggleButtonGroup } from '@mui/material'

import { IFilter } from 'src/components/filter/types/filter.types'
import { EAccountSubscriptionPlans } from 'src/types'

import { useStyles } from './styles'
import { HelperWrapper } from 'src/components/helper-wrapper'

interface IProps {
  total?: number
  free?: number
  plus?: number
  premium?: number
  enterprise?: number
  filter: IFilter
  setFilter: Dispatch<SetStateAction<IFilter>>
}

export const SubscriptionCount = ({
  free,
  plus,
  premium,
  enterprise,
  total,
  filter,
  setFilter,
}: IProps) => {
  const classes = useStyles()

  const handleChange = (e: any, value: EAccountSubscriptionPlans | undefined) => {
    if (value === null) return

    setFilter((prev) => ({ ...prev, subscription: value }))
  }

  return (
    <ToggleButtonGroup
      value={filter.subscription}
      exclusive
      size="small"
      onChange={handleChange}
      className={classes.buttonsGroup}
      disabled
    >
      <ToggleButton value={'all'}>
        <strong>
          <HelperWrapper t="total-count-title" />
        </strong>
        &nbsp;{total}
      </ToggleButton>
      <ToggleButton value={EAccountSubscriptionPlans.free}>
        <strong>{EAccountSubscriptionPlans.free}:</strong>&nbsp;{free}
      </ToggleButton>
      <ToggleButton value={EAccountSubscriptionPlans.plus}>
        <strong>{EAccountSubscriptionPlans.plus}:</strong>&nbsp;{plus}
      </ToggleButton>
      <ToggleButton value={EAccountSubscriptionPlans.premium}>
        <strong>{EAccountSubscriptionPlans.premium}:</strong>&nbsp;{premium}
      </ToggleButton>
      {enterprise && enterprise > 0 && (
        <ToggleButton value={EAccountSubscriptionPlans.enterprise}>
          <strong>{EAccountSubscriptionPlans.enterprise}:</strong>&nbsp;{enterprise}
        </ToggleButton>
      )}
    </ToggleButtonGroup>
  )
}
